import firebase from '@/plugins/firebase'
import pinia from '@/plugins/pinia'
import router from '@/plugins/router'
import vuetify from '@/plugins/vuetify'
import setup_chart from '@/plugins/chart'
import error from '@/plugins/error'
export const register_plugins = app => {
  app.use(firebase)
  app.use(pinia)
  app.use(router)
  app.use(vuetify)
  app.use(error)
  setup_chart()
}
